function mainFilesViewController(userViewService, $state) {
  const ctrl = this;

  ctrl.$onInit = () => {
    userViewService.setView('files');
  };
}

angular
  .module('package-management.module')
  .controller('mainFilesViewController', mainFilesViewController);
